import { render, staticRenderFns } from "./_base-button.vue?vue&type=template&id=b923293c"
var script = {}
import style0 from "./_base-button.vue?vue&type=style&index=0&id=b923293c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports